import React from "react";

import CasaRuufImage from "./HomeComponents/Images/CasaRuuf.png";
import { HomeGreeting } from "../../styles/texts";

import {
  UserData,
  UserBooking,
  SpecificBooking,
} from "../../types/responseTypes";
import ResumeBarPending2nd from "./HomeComponents/Resume/ResumeBarPending2nd";

interface HomePending2ndProps {
  userData: UserData;
  userBooking: UserBooking;
  specificBooking: SpecificBooking;
}

const HomePending2nd: React.FC<HomePending2ndProps> = ({
  userData,
  userBooking,
  specificBooking,
}) => {
  console.log("userData:", userData);
  console.log("userBooking:", userBooking);

  return (
    <div className="mb-10">
      <div className="flex flex-col items-center justify-center mb-10">
        <HomeGreeting userData={userData} userBooking={userBooking} />
        <img
          src={CasaRuufImage}
          alt="Casa Ruuf"
          className="w-1/8 md:w-1/8 mb-4"
        />
        
        {/* Para desarrollo local es util esto hee hee
        <div className="text-3xl font-bold text-gray-800 mb-4">
          Home Pending 2nd Signature
        </div>
        */}

        <div className="w-full max-w-xl md:max-w-2xl p-4 rounded-lg bg-white shadow-lg">
          <ResumeBarPending2nd 
            userData={userData} 
            userBooking={userBooking}
            specificBooking={specificBooking}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePending2nd;
